module.exports = __webpack_public_path__ + "img/exclusive_05.a6083fc0.jpg";